var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirm"},[_c('div',{staticClass:"alert"},[_c('h1',[_vm._v(_vm._s(_vm.message))]),_c('button',{on:{"click":function($event){return _vm.confirm()}}},[_vm._v("OK")])])])}
var staticRenderFns = []

export { render, staticRenderFns }